import React from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { SalesLetterSection } from './components/SalesLetterSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-cream" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SalesLetterSection data-id="element-3" />
      <WhatYouGetSection data-id="element-4" />
      <BonusSection data-id="element-5" />
      <PricingSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}